import React from "react";
import { SearchBarElement } from "@components_common/components/utils";

const CustomSearchBar = (props) => {
  return <SearchBarElement {...props} placeholder="Search my assets" />;
};

export default CustomSearchBar;
